export enum RecommendationSecurityLimitFrequency {
	daily = 1,
	monthly = 2,
}
